import { render, staticRenderFns } from "./EventStatistics.vue?vue&type=template&id=2db88baf&scoped=true&"
import script from "./EventStatistics.vue?vue&type=script&lang=js&"
export * from "./EventStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EventStatistics.vue?vue&type=style&index=0&id=2db88baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db88baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db88baf')) {
      api.createRecord('2db88baf', component.options)
    } else {
      api.reload('2db88baf', component.options)
    }
    module.hot.accept("./EventStatistics.vue?vue&type=template&id=2db88baf&scoped=true&", function () {
      api.rerender('2db88baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/event/EventStatistics.vue"
export default component.exports